// extracted by mini-css-extract-plugin
export default {"container":"Products_container__c5AnJ","grid":"Products_grid__EiX0B","empty":"Products_empty__K2vF7"};